import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardHeader, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import _ from "lodash";

import DefaultDataGrid from "modules/5_view_helpers/web/DefaultDataGrid";
import columns from "./columns";

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";

// Actions
import { getProjectTwrCategories } from "../actions";

function mapStateToProps(state) {
  return {
    project_twr_categories: state.project_twr_categories,
  };
}

const ProjectTwrCategoriesIndex = (props) => {
  useEffect(() => {
    props.getProjectTwrCategories();
  }, []);

  const { project_twr_categories } = props;

  const readRole = HasRole({ resource_type: "Project::Twr::Category", name: ["read", "moderator"] });
  const createRole = HasRole({ resource_type: "Project::Twr::Category", name: ["create", "moderator"] });
  const updateRole = HasRole({ resource_type: "Project::Twr::Category", name: ["update", "moderator"] });

  if (!readRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Card>
        <CardHeader>
          <Row>
            <Col>
              <h3>Categories</h3>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          {createRole && (
            <Row>
              <Col>
                <Link to={`/project/twr/categories/new`}>
                  <Button color="primary" size="md">
                    <i className="fa fa-plus"> Create New Category</i>
                  </Button>
                </Link>
              </Col>
            </Row>
          )}

          <Row className="mt-2">
            <Col>
              <DefaultDataGrid columns={columns(updateRole)} data={project_twr_categories} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
};
export default connect(mapStateToProps, { getProjectTwrCategories })(ProjectTwrCategoriesIndex);
